import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { DPBILL_DETAIL_REPORT, } from "@frameworks/web/redux/interfaces/Reports/iDpBills";
const initState = {
    dpBillReport: []
};
const DpBillReportReducer = (state = initState, action) => {
    switch (action.type) {
        case DPBILL_DETAIL_REPORT:
            return Object.assign(Object.assign({}, state), { dpBillReport: action.payload.dpBillReport });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: DpBillReportReducer,
    commonData: commonOnePlatFormReducer,
});
